import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { PopulatedEntitySuggestion } from '@bliks-io/contracts';
import { UserCard, toUserCardProps } from '@bliks-io/ui';
import { SuggestionSourceLabel } from '@/pages/my-tasks/components/SuggestionSourceLabel';
import { SuggestionProcessPreviewDialog } from '@/pages/my-tasks/components/SuggestionProcessPreviewDialog';

interface RecordingContextBlockProps {
  suggestion: PopulatedEntitySuggestion;
  onPreviewClick: () => void;
}

export function RecordingContextBlock({ suggestion, onPreviewClick }: RecordingContextBlockProps) {
  const { t, i18n } = useTranslation();
  const [showProcessInfo, setShowProcessInfo] = useState(false);

  const submittedDate = new Date(suggestion.submittedAt).toLocaleString(i18n.language, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });

  return (
    <div className="rounded border bg-muted/30 p-3 text-sm">
      <dl className="grid grid-cols-[max-content_1fr] gap-x-3 gap-y-2">
        <dt className="text-muted-foreground">{t('entitySuggestion.review.submittedBy')}</dt>
        <dd>
          <UserCard
            user={toUserCardProps(suggestion.submittedBy)}
            variant="with-role"
            itemVariant="outline"
            size="sm"
          />
        </dd>
        <dt className="text-muted-foreground">{t('entitySuggestion.review.submittedAt')}</dt>
        <dd>{submittedDate}</dd>
        <dt className="text-muted-foreground">{t('entitySuggestion.review.sourceRecording')}</dt>
        <dd>
          <SuggestionSourceLabel
            suggestion={suggestion}
            className="w-full"
            onProcessClick={() => setShowProcessInfo(true)}
            onStepClick={suggestion.sourceRecordingId ? onPreviewClick : undefined}
          />
        </dd>
      </dl>

      <SuggestionProcessPreviewDialog
        suggestion={suggestion}
        open={showProcessInfo}
        onClose={() => setShowProcessInfo(false)}
      />
    </div>
  );
}
